/**
 * v4.8.0 — Operational Intelligence Tokens (shared frontend layer).
 *
 * Mirrors backend `intelligence/severity.py`. All Phase 8.x surfaces
 * import from here — never inline severity colors.
 */

export const SEVERITY_TOKENS = {
    low: {
        text: "#94A3B8",
        bg: "rgba(148, 163, 184, 0.10)",
        border: "rgba(148, 163, 184, 0.30)",
        glow: "rgba(148, 163, 184, 0.18)",
    },
    moderate: {
        text: "#FCD34D",
        bg: "rgba(245, 158, 11, 0.10)",
        border: "rgba(245, 158, 11, 0.32)",
        glow: "rgba(245, 158, 11, 0.20)",
    },
    high: {
        text: "#FB923C",
        bg: "rgba(251, 146, 60, 0.10)",
        border: "rgba(251, 146, 60, 0.32)",
        glow: "rgba(251, 146, 60, 0.22)",
    },
    critical: {
        text: "#FCA5A5",
        bg: "rgba(248, 113, 113, 0.10)",
        border: "rgba(248, 113, 113, 0.36)",
        glow: "rgba(248, 113, 113, 0.24)",
    },
};

export const RECOVERY_CONFIDENCE_TOKENS = {
    stable:              { text: "#A7F3D0", bg: "rgba(16, 185, 129, 0.10)" },
    recovery_likely:     { text: "#A7F3D0", bg: "rgba(16, 185, 129, 0.10)" },
    at_risk:             { text: "#FCD34D", bg: "rgba(245, 158, 11, 0.10)" },
    escalation_likely:   { text: "#FCA5A5", bg: "rgba(248, 113, 113, 0.10)" },
};

export const formatAge = (hours) => {
    if (hours == null) return "—";
    if (hours < 1) return `${Math.max(0, Math.round(hours * 60))}m`;
    if (hours < 24) return `${Math.round(hours)}h`;
    return `${Math.round(hours / 24)}d`;
};
